import { useState } from 'react';

import { FILTER_OPTIONS } from './CustomFilterCards';
import { useCustomTransfersStore } from '@lib/transfers/store/useCustomTransfersStore';
import Button from '@components/atoms/button';
import Icon from '@components/atoms/icon';
import { BodyRegular, BodyRegularBold } from '@components/atoms/typography';

export const CustomTransferFilterPicker = () => {
  const [isOpen, setIsOpen] = useState(false);
  const layoutOrder = useCustomTransfersStore((state) => state.layoutOrder);
  const addLayoutCard = useCustomTransfersStore((state) => state.addLayoutCard);

  const availableFilters = FILTER_OPTIONS.filter(
    (option) => !layoutOrder.includes(option.card)
  );

  return (
    <div
      className="relative inline-block"
      onClick={(event) => event.stopPropagation()}
      data-cy="filter-picker"
    >
      <Button
        variant="secondary"
        onClick={() => setIsOpen((open) => !open)}
        dataCy="filter-picker-toggle"
      >
        Add filter
      </Button>

      {isOpen && availableFilters.length > 0 && (
        <div className="absolute top-12 left-0 z-40 bg-white border border-neutral-200 rounded-lg shadow-300 py-2 min-w-[240px]">
          {availableFilters.map(({ card, label, iconName }) => (
            <button
              key={card}
              type="button"
              className="w-full flex items-center gap-2 px-4 py-2 hover:bg-neutral-50 text-left"
              onClick={() => {
                addLayoutCard(card);
                setIsOpen(false);
              }}
              data-cy={`add-filter-${card}`}
            >
              <Icon
                name={iconName}
                className="text-neutral-600 w-5 h-5 flex-shrink-0"
              />
              <BodyRegularBold className="mb-0">{label}</BodyRegularBold>
            </button>
          ))}
        </div>
      )}

      {isOpen && availableFilters.length === 0 && (
        <div className="absolute top-12 left-0 z-40 bg-white border border-neutral-200 rounded-lg shadow-300 px-4 py-3 min-w-[240px]">
          <BodyRegular className="mb-0 text-neutral-600">
            All filters added.
          </BodyRegular>
        </div>
      )}
    </div>
  );
};
